/* eslint-disable import/prefer-default-export */
// https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
export const isIos = () => {
  return (
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
      navigator.platform
    ) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
};

// https://stackoverflow.com/questions/6031412/detect-android-phone-via-javascript-jquery
export const isAndroid = () => navigator.userAgent?.toLowerCase()?.includes('android');
